import { ResolvedPartConfigurationBomLine } from "src/api/generated/erp/configurator/configurationResolving/bom/resolvedPartConfigurationBomLine";
import { PartConfiguratorType } from "src/api/generated/erp/configurator/configuratorType/partConfiguratorType";
import { SubConfiguratorPartConfiguratorType } from "src/api/generated/erp/configurator/configuratorType/impl/subConfiguratorPartConfiguratorType";
import { ConfigurationPropertyValues } from "src/api/generated/erp/configurator/model/configurationPropertyValues";

export function createBomLineSubConfiguratorType(
	row: Pick<ResolvedPartConfigurationBomLine, "bomLineCatalogPartId" | "subConfiguratorListIndex">,
	parentConfiguratorType: PartConfiguratorType,
	parentProperties: ConfigurationPropertyValues,
): SubConfiguratorPartConfiguratorType {
	return {
		type: "subConfigurator",
		parentConfiguratorType,
		parentProperties,
		subConfiguratorCatalogPartId: row.bomLineCatalogPartId,
		configuratorVersion: null,
		subConfiguratorListIndex: row.subConfiguratorListIndex,
	};
}
